import { Input } from "./input";
import { Label } from "./label";
import { UseFormRegisterReturn } from "react-hook-form";

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    error?: string;
    registration: UseFormRegisterReturn;
    required?: boolean;
    touched?: boolean;
}

export const FormField = ({
    label,
    error,
    registration,
    required,
    touched,
    ...props
}: FormFieldProps) => {
    return (
        <div className="space-y-1.5">
            <Label htmlFor={props.id} className="flex gap-0.5">
                {label}
                {required && <span className="text-destructive">*</span>}
            </Label>
            <Input id={props.id} {...registration} {...props} />
            {touched && error && <p className="text-xs text-destructive">{error}</p>}
        </div>
    );
};
